import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

interface CompanyData {
  name: string;
  country: string;
  description: string | null;
  website: string | null;
  sectors: string[];
  logo_url: string | null;
  company_type: string | null;
  spa_linked: boolean;
  spa_role_description: string | null;
}

const FIELDS = [
  'name', 'country', 'description', 'website', 'sectors',
  'logo_url', 'company_type', 'spa_info',
] as const;

export function CompanyCompleteness({ company }: { company: CompanyData | null }) {
  const { t } = useTranslation();
  if (!company) return null;

  const filled = FIELDS.filter(f => {
    if (f === 'sectors') return company.sectors.length > 0;
    if (f === 'spa_info') return !company.spa_linked || !!company.spa_role_description;
    const val = company[f as keyof CompanyData];
    return val != null && val !== '';
  }).length;

  const pct = Math.round((filled / FIELDS.length) * 100);

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium">{t('companyProfile.completeness')}</span>
          <span className="text-sm text-muted-foreground">{filled}/{FIELDS.length}</span>
        </div>
        <Progress value={pct} className="h-2" />
        {pct < 100 && (
          <p className="text-xs text-muted-foreground mt-2">{t('companyProfile.completenessHint')}</p>
        )}
      </CardContent>
    </Card>
  );
}
